// extracted by mini-css-extract-plugin
export default {"form":"style_form__dKu0+","input":"style_input__k-+E6","button":"style_button__A0h45","have_code":"style_have_code__j28nf"};